export enum ColorTagColor {
  RED = "red",
  ORANGE = "orange",
  YELLOW = "yellow",
  GREEN = "green",
  BLUE = "blue",
  PURPLE = "purple",
  PINK = "pink",
  GRAY = "gray",
}

export interface IUserColorTag {
  id: string;
  userId: string;
  colorTagId: string;
  colorTag: IColorTag;
  createdAt: string;
}

export interface IColorTag {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  name: ColorTagColor;
  description: string;
  color: string;
  status: string;
}

export type CreateColorTagDto = {
  name: ColorTagColor;
  color: string;
  description: string;
};

export type UpdateColorTagDto = Partial<CreateColorTagDto>;

export type AssignColorTagDto = {
  userId: string;
  colorTagId: string;
};
